import React, { FC } from 'react'
// @ts-ignore
import { BrowserRouter } from 'react-router-dom'
// @ts-ignore
import { HashLink } from 'react-router-hash-link'
import './LeadingWealthManager.scss'
import { LeadingWealthManagerTypes } from './LeadingWealthManager.types'
import { sanitizeHTML, utilizeScroll } from '../../utils/common-utils'

export const LeadingWealthManager: FC<LeadingWealthManagerTypes> = props => {
  const {
    backgroundImageUrl,
    heading,
    subHeading,
    overlayDescription,
    leftImageUrl,
    middleImageUrl,
    rightImageUrl,
    leftImageAlt,
    middleImageAlt,
    rightImageAlt,
    leftImageContent,
    middleImageContent,
    rightImageContent,
    sourceInfoText,
    sourceInfoUrl,
  } = props?.content || {}

  return (
    <BrowserRouter>
      <div
        id='leading-wealth-manager'
        className='leading-wealth-manager Content Content--reversed u-paddingVert64 u-bgSizeCover'
        style={{
          backgroundImage: `url(${backgroundImageUrl})`,
        }}>
        <div className='u-sizeConstrained'>
          <div
            className=''
            dangerouslySetInnerHTML={{
              __html: sanitizeHTML(heading) || '',
            }}
          />
          <div
            className='u-marginVert48'
            dangerouslySetInnerHTML={{
              __html: sanitizeHTML(subHeading) || '',
            }}
          />
          <div className='fs-box u-padding48'>
            <div
              className='u-marginBottom48'
              dangerouslySetInnerHTML={{
                __html: sanitizeHTML(overlayDescription) || '',
              }}
            />

            <div className='overlay-content u-flex u-sm-flexCol u-flexJustifyBetween'>
              <div className='left-content'>
                <div className='left-image u-flex u-flexAlignItemsCenter u-flexJustifyCenter'>
                  <img src={leftImageUrl} alt={leftImageAlt} />
                </div>
                <div
                  className='u-marginTop40'
                  dangerouslySetInnerHTML={{
                    __html: sanitizeHTML(leftImageContent) || '',
                  }}
                />
              </div>
              <div className='middle-content'>
                <div className='middle-image u-flex u-flexAlignItemsCenter u-flexJustifyCenter'>
                  <img src={middleImageUrl} alt={middleImageAlt} />
                </div>
                <div
                  className='u-marginTop40'
                  dangerouslySetInnerHTML={{
                    __html: sanitizeHTML(middleImageContent) || '',
                  }}
                />
              </div>
              <div className='right-content'>
                <div className='right-image u-flex u-flexAlignItemsCenter u-flexJustifyCenter'>
                  <img src={rightImageUrl} alt={rightImageAlt} />
                </div>
                <div
                  className='u-marginTop40'
                  dangerouslySetInnerHTML={{
                    __html: sanitizeHTML(rightImageContent) || '',
                  }}
                />
              </div>
            </div>
            <div className='u-flex u-flexJustifyEnd u-marginTop20'>
              <HashLink
                scroll={(el: any) => utilizeScroll(`#${sourceInfoUrl}`, 100)}
                to={`#${sourceInfoUrl}`}>
                {sourceInfoText}
              </HashLink>
            </div>
          </div>
        </div>
      </div>
    </BrowserRouter>
  )
}
